import difference from 'lodash.difference';
import { distinctUntilChanged, bufferCount, mapTo, filter, bufferWhen, groupBy, mergeMap, windowWhen, first, pluck } from 'rxjs/operators';
function keyPresses(keyUp) {
    return function (observable) {
        return observable.pipe(groupBy(function (e) { return e.keyCode; }), mergeMap(function (group) {
            return group.pipe(windowWhen(function () { return keyUp.pipe(filter(function (e) { return e.keyCode === group.key; })); }), mergeMap(function (window) { return window.pipe(distinctUntilChanged(), first()); }));
        }));
    };
}
function multiKeyPresses(keyUp) {
    return function (observable) {
        return observable.pipe(keyPresses(keyUp), pluck('keyCode'), bufferWhen(function () { return keyUp; }), filter(function (buffer) { return buffer.length > 0; }));
    };
}
export function keyPressSequence(sequence, keydown, keyup) {
    return keydown.pipe(multiKeyPresses(keyup), bufferCount(sequence.length), filter(function (buffer) { return sequenceEquals(buffer, sequence); }), mapTo(true));
}
function sequenceEquals(sequence1, sequence2) {
    for (var i = 0; i < sequence1.length; i++) {
        var keySet1 = sequence1[i];
        var keySet2 = sequence2[i];
        if (keySet1.length !== keySet2.length) {
            return false;
        }
        if (difference(keySet1, keySet2).length > 0) {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=keypresses.operator.js.map